import {
  Classes,
  Dialog,
  InputGroup,
  NonIdealState,
} from "@blueprintjs/core";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { FornecedoresStore } from "../../stores/relatorio/FornecedoresStore";
import {
  MDBBtn,
  MDBCol,
  MDBModalBody,
  MDBRow,
} from "mdbreact";
import { IEmpresa } from "../../model";
import * as utils from "../../utils";
import {
  BootstrapTable,
  SearchField,
  TableHeaderColumn,
} from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { observable } from "mobx";
import LoadingModal from "../loading/LoadingModal";

var debounce = require('lodash.debounce');

interface FornecedoresPageState {
  date1: string;
  date2: string;
  date: any;
}

@observer
export default class FornecedoresPage extends React.Component<any, FornecedoresPageState> {

  obs = observable({
    fetchOptions: {} as any
  });

  constructor(props: {}) {
    super(props);
    AppStore.setTitle("Fornecedores");

    this.obs.fetchOptions = debounce(this.handleSearch.bind(this), 800);

  }

  async componentDidMount() {

    FornecedoresStore.obs.filter = ""
    FornecedoresStore.obs.currentPage = 1

    await FornecedoresStore.loadFornecedores(1, FornecedoresStore.obs.filter);
  }

  handlePageChange = async (page: number) => {

    await FornecedoresStore.loadFornecedores(page, FornecedoresStore.obs.filter);

  };

  handleSearch = async (e) => {

    await FornecedoresStore.loadFornecedoresFilter(1, FornecedoresStore.obs.filter);

  };

  loadFornecedoresFilter = (e) => {

    FornecedoresStore.obs.filter = e
    FornecedoresStore.obs.currentPage = 1

    this.obs.fetchOptions()

  };

  refresh = () => {
    window.location.reload();
  };

  handleEdit(empresa: IEmpresa) {
    AppStore.setLocation(`/empresa/edit/${empresa.cipher_id}`);
  }

  onSelectAll = (isSelected) => {
    if (isSelected) {
      return [];
    } else {
      return [];
    }
  };

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );
  };

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ marginLeft: 12 }}>
        Mostrando {start} a {to} de {total} resultados.&nbsp;&nbsp;
      </p>
    );
  }

  renderData() {
    let items = FornecedoresStore.obs.fornecedores?.map(cnpj => {
      return (
        {
          cipher_id: cnpj.id,
          identificador: cnpj.sped_id,
          id: cnpj.nome,
          name: utils.formatCnpj(cnpj.cnpj),
          endereco: cnpj.logradouro + ", " + cnpj.uf + " | CEP: " + cnpj.cep,
        }
      );
    });

    function handleView(row) {
      FornecedoresStore.viewFornecedorReq(row);
      FornecedoresStore.obs.viewFornecedor = true;
    }

    function buttonFormatter(cell, row) {
      return (
        <MDBBtn
          color="default"
          rounded
          size="sm"
          onClick={(e) => handleView(row)}
        >
          <img src="/images/view.png" width="18px" />
        </MDBBtn>
      );
    }

    let ativiPrin = FornecedoresStore.obs.atividadesPrincipais?.map(ativ => {
      return <p key={ativ}>{ativ}</p>;
    });

    let ativiSec = FornecedoresStore.obs.atividadesSecundarias?.map(ativs => {
      return <p key={ativs}>{ativs}</p>;
    });

    return (
      <div className="empresas-page">
        <LoadingModal open={FornecedoresStore.obs.waitFornecedores} onClose={() => FornecedoresStore.obs.waitFornecedores = false} title={"Buscando fornecedores"} />
        <Dialog
          isOpen={FornecedoresStore.obs.viewFornecedor}
          onClose={(e) => FornecedoresStore.obs.viewFornecedor = false}
          title="Dados do Fornecedor"
          className="dados-soli"
        >
          <MDBModalBody style={{ height: 500, overflow: 'auto' }}>
            <div className={Classes.DIALOG_BODY}>
              <div style={{ marginBottom: 10, fontSize: 10 }}>
                <MDBRow>
                  {FornecedoresStore.obs.Fornecedor &&
                    (
                      <>
                        <MDBCol md="6">
                          <p>
                            <b>Razão Social:</b>{" "}
                            {FornecedoresStore.obs.Fornecedor.nome}
                          </p>
                          <p>
                            <b>Nome Fantasia:</b>{" "}
                            {FornecedoresStore.obs.Fornecedor.fantasia}
                          </p>
                          <p>
                            <b>CNPJ:</b> {FornecedoresStore.obs.Fornecedor.cnpj}
                          </p>
                          <p>
                            <b>Logradouro:</b>{" "}
                            {FornecedoresStore.obs.Fornecedor.logradouro}{" "}
                            {FornecedoresStore.obs.Fornecedor.complemento},{" "}
                            {FornecedoresStore.obs.Fornecedor.numero}
                          </p>
                          <p>
                            <b>Bairro:</b> {FornecedoresStore.obs.Fornecedor.bairro}
                            {" "}
                            ({FornecedoresStore.obs.Fornecedor.cep})
                          </p>
                          <p>
                            <b>Cidade / Estado:</b>{" "}
                            {FornecedoresStore.obs.Fornecedor.municipio},{" "}
                            {FornecedoresStore.obs.Fornecedor.uf}
                          </p>
                        </MDBCol>
                        <MDBCol md="6">
                          <p>
                            <b>Natureza Jurídica:</b>{" "}
                            {FornecedoresStore.obs.Fornecedor.natureza_juridica}
                          </p>
                          <p>
                            <b>Porte:</b> {FornecedoresStore.obs.Fornecedor.porte}
                          </p>
                          <p>
                            <b>Tipo:</b> {FornecedoresStore.obs.Fornecedor.tipo}
                          </p>
                          <p>
                            <b>Situação:</b>{" "}
                            {FornecedoresStore.obs.Fornecedor.situacao}
                          </p>
                          <p>
                            <b>Data Abertura:</b>{" "}
                            {FornecedoresStore.obs.Fornecedor.abertura}
                          </p>
                          <p>
                            <b>Data última situação:</b>{" "}
                            {FornecedoresStore.obs.Fornecedor.data_situacao}
                          </p>
                          <p>
                            <b>Contatos:</b>{" "}
                            {FornecedoresStore.obs.Fornecedor.telefone} -{" "}
                            {FornecedoresStore.obs.Fornecedor.email}
                          </p>
                        </MDBCol>
                        <MDBCol md="12">
                          <h3 className="titleProccess titleCnae">
                            CNAE Principal
                          </h3>
                          {ativiPrin}
                        </MDBCol>
                        <MDBCol md="12">
                          <h3 className="titleProccess titleCnae">
                            CNAEs Secundários
                          </h3>
                          {ativiSec}
                        </MDBCol>
                      </>
                    )}
                </MDBRow>
              </div>
            </div>
          </MDBModalBody>
        </Dialog>

        <MDBRow>
          <MDBCol md="6" className="inputFilter">
            <InputGroup
              round
              leftIcon="search"
              style={{ width: 600, borderRadius: "10px" }}
              placeholder="Filtrar (Razão Social, CNPJ)"
              value={FornecedoresStore.obs.filter}
              onChange={(e: any) => this.loadFornecedoresFilter(e.target.value)}
            />
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol md="12" sm="12" xs="12">
            <BootstrapTable
              className="TableDefault"
              ref="table"
              data={items}
            >
              <TableHeaderColumn dataField="cipher_id" isKey={true} hidden>
                #
              </TableHeaderColumn>
              <TableHeaderColumn dataField="identificador" width={"15%"}>
                ID
              </TableHeaderColumn>
              <TableHeaderColumn dataField="id" dataSort={true} width={"40%"}>
                Razão Social
              </TableHeaderColumn>
              <TableHeaderColumn dataField="name" dataSort={true} width={"15%"}>
                CNPJ
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="endereco"
                dataSort={true}
                width={"35%"}
              >
                Endereço
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={buttonFormatter} width={"10%"}>
                Detalhes
              </TableHeaderColumn>
            </BootstrapTable>
          </MDBCol>
        </MDBRow>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={FornecedoresStore.obs.currentPage}
            totalCount={FornecedoresStore.obs.fornecedores_length}
            pageSize={20}
            onPageChange={page => this.handlePageChange(FornecedoresStore.obs.currentPage = page)}
          />
        </div>
      </div>
    );
  }

  renderNonIdeal() {
    return (
      <div className="nz-non-ideal">
        <NonIdealState
          icon="box"
          title="Você não possui permissão para acessar essa página"
        />
      </div>
    );
  }

  renderNormal() {

    return (
      <>
        {this.renderData()}
      </>
    );
  }

  render() {
    let niveis_acesso = AppStore.obs1.usuario
      ? AppStore.obs1.usuario.niveis_acesso
      : [""];
    if (niveis_acesso.indexOf("l1") == -1) {
      return this.renderNonIdeal();
    } else {
      return this.renderNormal();
    }
  }
}
